import { MarginType, PrintTemplateName } from "../../../interfaces/print";

export const MAP_MARGIN: MarginType = [108, 72, 72, 72];
export const MAP_LEGEND_LEFT_MARGIN: MarginType = [108, 72, 72, 413];
export const MAP_LEGEND_RIGHT_MARGIN: MarginType = [108, 413, 72, 72];
export const LEGEND_MARGIN: MarginType = [0, 40, 0, 40];
export const DEFAULT_MARGIN: MarginType = [0, 0, 0, 0];
export const VERTICAL_LEGEND_WIDTH = 269;
export const HORIZONTAL_LEGEND_WIDTH = 293;

export const templateConfig = {
  Default: {
    name: PrintTemplateName.Default,
    margin: DEFAULT_MARGIN,
  },
  Map: {
    name: PrintTemplateName.Map,
    margin: MAP_MARGIN,
  },
  MapLegendLeft: {
    name: PrintTemplateName.MapLegendLeft,
    margin: MAP_LEGEND_LEFT_MARGIN,
  },
  MapLegendRight: {
    name: PrintTemplateName.MapLegendRight,
    margin: MAP_LEGEND_RIGHT_MARGIN,
  },
  MapLegendBottom: {
    name: PrintTemplateName.MapLegendBottom,
    margin: MAP_MARGIN,
  },
  LegendVertical: {
    name: PrintTemplateName.LegendVertical,
    margin: LEGEND_MARGIN,
  },
  LegendHorizontal: {
    name: PrintTemplateName.LegendHorizontal,
    margin: LEGEND_MARGIN,
  },
};
